import { useReceivedVouches } from '../../../hooks/useReceivedVouches';
import './ReceivedVouches.scss';

function daysLeft(iso: string): number {
  return Math.max(0, Math.ceil((new Date(iso).getTime() - Date.now()) / 86_400_000));
}

export function ReceivedVouches() {
  const enabled = import.meta.env.VITE_ENABLE_VOUCHING === 'true';
  const { received } = useReceivedVouches();
  if (!enabled || received.length === 0) return null;
  return (
    <div className="received-vouches">
      {received.map((v) => (
        <p key={v.vouchId} className="received-vouches__item">
          Vouched by <strong>@{v.sharerUsername}</strong> — reach boosted for{' '}
          {daysLeft(v.windowEndsAt)} more days
        </p>
      ))}
    </div>
  );
}
